import { FormAbstract } from "./FormAbstract";
import { ISpareParts } from "../../Interfaces/Appointments";
import { postRequest } from "./Data";
import { Toast } from "../../Components/Dialog/Toast";
import { ABSTRACT, SPARE_PARTS } from "./Constants";

class SpareParts extends FormAbstract {
    static section = document.querySelector<HTMLElement>(SPARE_PARTS.SELECTORS.section);

    constructor(form: HTMLFormElement) {
        super(form);
        this.key = "spare-parts-form";
        const firstTab = this.tabs.item(0).dataset.tab;
        FormAbstract.activateTab(firstTab);
        FormAbstract.updateUrl(firstTab);
        this.initListeners();
    }

    async submit(e: Event) {
        e.preventDefault();

        const formData = this.getFormData(this.form);

        this.state.request = {
            ...this.state.request,
            ...(Object.fromEntries(formData) as { [key: string]: string })
        };

        const formattedState = {
            ...this.state,
            request: this.prepareRequest(this.state.request as ISpareParts)
        };

        if (this.checkAllFormsValidity() && this.form.checkValidity()) {
            this.loader.render();
            try {
                await postRequest(formattedState.request, "spare-part");

                new Toast({
                    title: window.SuccessMessages.purchaseRequest.success,
                    type: Toast.TYPE_SUCCESS
                })?.render();

                this.loader.destroy();

                this.resetForms();
            } catch (e) {
                console.error(e);

                this.loader.destroy();

                new Toast({
                    title: window.SuccessMessages.purchaseRequest.error,
                    type: Toast.TYPE_ERROR
                })?.render();
            }
        }

        this.form.dispatchEvent(new CustomEvent("form:next"));
    }

    private prepareRequest(request: ISpareParts): ISpareParts {
        const { ...data } = request;

        data.already_customer = data.already_customer && data.already_customer === "1" ? "true" : "false";
        data.fgnr = Number(data.fgnr);
        data.amount = Number(data.amount);
        data.store = this.store;
        data.locale = this.locale;

        return {
            ...data
        };
    }

    get store() {
        return SpareParts.section.dataset.store;
    }

    get locale() {
        return SpareParts.section.dataset.locale;
    }
}

if (SpareParts.section) {
    const forms = SpareParts.section.querySelectorAll(ABSTRACT.SELECTORS.form);
    if (forms.length > 0) {
        forms.forEach((form: HTMLFormElement) => {
            new SpareParts(form);
        });
    }
}
